import React, { useState } from 'react';
import Layout from '../Layout';
import { Breadcrumbs, Link, Typography, Container, Box, Grid, TextField, Select, MenuItem, FormControl, InputLabel, Switch, FormControlLabel, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector } from 'react-redux';

const EditCheckPoint = () => {
    const [checkpoints, setCheckpoints] = useState([]);
    const { formData } = useSelector(state => state.form);
    const data = formData && formData[0];
    console.log("datahhhhhh", formData);

    const addRow = () => {
        setCheckpoints([...checkpoints, { type: '', name: '', value: '' }]);
    };

    const handleChange = (index, field, value) => {
        const updatedCheckpoints = checkpoints.map((checkpoint, i) => (
            i === index ? { ...checkpoint, [field]: value } : checkpoint
        ));
        setCheckpoints(updatedCheckpoints);
    };

    const handleDelete = (index) => {
        setCheckpoints(checkpoints.filter((_, i) => i !== index));
    };

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Edit Checkpoint
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link color="inherit" href="/">
                            Home
                        </Link>
                        <Link color="inherit" href="/preventive-maintenance">
                            Preventive Maintenance
                        </Link>
                        <Link color="inherit" href="/create-plan">
                            Create Plan
                        </Link>
                        <Link color="inherit" href="/add-plan/*">
                            Add/View Plan
                        </Link>
                        <Typography color="textPrimary">Edit Checkpoint</Typography>
                    </Breadcrumbs>
                </Box>
                <Box className="add-checkpoint" mb={3}>
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Add a Checkpoint
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                style={{ backgroundColor: '#3f51b5', color: 'white', fontSize: "12px", fontWeight: "400" }}
                            >
                                Import from CSV
                            </Button>
                        </Grid>
                        <Grid container spacing={3}>
                            {data && <Grid item xs={12} className='checkpoint-details'>
                                <p>Asset : {data.assetNo}</p>
                                <p>Checkpoint : {data.checkpoint}</p>
                                <p>Frequency : {data.frequency}</p>
                                <p>Start Date : {data.startDate}</p>
                                <p>Enabled : <FormControlLabel
                                    control={
                                        <Switch
                                            checked={data.enabled}
                                            name="enabled"
                                            color="primary"
                                        />
                                    }
                                /></p>
                            </Grid>}
                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        fullWidth
                                        style={{ backgroundColor: '#3f51b5', color: 'white', fontSize: "12px", fontWeight: "400" }}
                                        onClick={addRow}
                                    >
                                        Add Row
                                    </Button>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        fullWidth
                                        style={{ backgroundColor: '#3f51b5', color: 'white', fontSize: "12px", fontWeight: "400" }}
                                    >
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>


                <Box className="add-checkpoint">
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Checkpoints List
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        <Grid item xs={3}>
                            <h4>Type</h4>
                        </Grid>
                        <Grid item xs={3}>
                            <h4>Name</h4>
                        </Grid>
                        <Grid item xs={3}>
                            <h4>Value</h4>
                        </Grid>
                        <Grid item xs={3}>
                            <h4>Action</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {checkpoints.map((checkpoint, index) => (
                        <Grid container spacing={3} alignItems='center' key={index}>
                            <Grid item xs={3}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Select type</InputLabel>
                                    <Select
                                        label="Select type"
                                        name="type"
                                        value={checkpoint.type}
                                        onChange={(e) => handleChange(index, 'type', e.target.value)}
                                    >
                                        <MenuItem value="static">Static</MenuItem>
                                        <MenuItem value="user_entry">User Entry</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="Name"
                                    name="name"
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={checkpoint.name}
                                    onChange={(e) => handleChange(index, 'name', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="Value"
                                    name="value"
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={checkpoint.value}
                                    onChange={(e) => handleChange(index, 'value', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <DeleteIcon onClick={() => handleDelete(index)} />
                            </Grid>
                        </Grid>
                    ))}
                    <hr />

                </Box>
            </Container>
        </Layout>
    );
};

export default EditCheckPoint;
